import type { RootState } from '@/redux/index'
import {
  createAppSelector,
  optionsInGroupCombiner,
} from '@/redux/utils'

export const selectAccessibleEmployees = createAppSelector([
  (state) => state.employee.employees,
  (state) => state.global.permissionKey,
], (employees, permissionKey) => employees[permissionKey])

export const selectEmployeeOptions = createAppSelector([
  selectAccessibleEmployees,
  (state) => state.group.groups,
], optionsInGroupCombiner)

export const selectCurrentEmployee = (state: RootState) => state.employee.currentEmployee
